import { Link } from "react-router-dom";
import { tokens } from "../../../styles/theme";
import React, { useEffect, useState } from "react";
import { Box, useTheme, Button } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../global/ConfirmDialog";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import { getAllProvidersMTN } from "../../../services/ProvidersMTNService";
import packageJson from "../../../../package.json";
import * as sweetalert from "sweetalert";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;

function EditToolbar(props) {
 
  return (
    <>
      <GridToolbarContainer>
      <Box className="div-btn-header">
          <Button
            component={Link}
            variant="contained"
            className="btn-submit"
            color="secondary"
            to="/create-provider-mtn"
          >
            اضافة نقطة بيع
          </Button>
          <Button
            component={Link}
            variant="contained"
            className="btn-submit"
            color="secondary"
            to="/provider-mtn-setting"
            style={{marginLeft:'10px'}}
          >
            إعدادات  نقطة البيع
          </Button>
        </Box>
      </GridToolbarContainer>

      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport csvOptions={{
          fileName: "الطلبات",
          utf8WithBom: true,
        }}/>
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const Provider_MTN = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();

  useEffect(() => {
    setIsLoading(true);

    getAllProvidersMTN()
      .then((res) => {
        setUsers(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
      
        setUsers([]);
        setIsLoading(false);
      });

    return () => {
    
    };
  }, []);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleView = (id) => () => {
    navigate(`/provider-mtn/${id}`, { state: { id: id, mod: 'View' } });
  };
  const handleUpdate = (id) => () => {
    navigate(`/provider-mtn/${id}`, { state: { id: id, mod: 'update' } });
  };


  const handleDeleteClick = id => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });

    axios
      .delete(`${BaseUrl}/api/distributor/${id}`, {
        withCredentials: true,
      })
      .then((res) => {
        sweetalert(res.data.msg, {
          className: "alert-div",
          button: {
            text: "تم",
          },
        });
        setUsers(users.filter((row) => row.id !== id));
      })
      .catch((err) => {});
  };



  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const columns = [
    {
      field: "DealerCode",
      headerName: "كود نقطة البيع",
      
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "DealerPass",
      headerName: "كلمة مرور نقطة البيع",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "DealerPassCache",
      headerName: "  كلمة مرور نقطة البيع كاش",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "DealerUserName",
      headerName: "اسم مستخدم نقطة البيع",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "OwnerDistributor",
      headerName: " مالك نقطة البيع",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "DealerGSM",
      headerName: "سيمة نقطة البيع",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "GPS",
      headerName: "الموقع",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "اجراءات",
      headerAlign: "center",
      align: "center",
      width: 900,
      minWidth: 500,
      maxWidth: 200,
      cellClassName: "actions",
      renderCell: ({ id }) => {
      
        return (
          <Box>

            <Button
              variant="contained"
              color="primary"
              className="viewbtn"
              onClick={handleView(id)}
            >
              استعراض
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="activationbtn"
              onClick={handleUpdate(id)}
            >
              تعديل
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="activationbtn3"
              onClick={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: "هل تريد حذف هذه السجل؟",
                  subTitle: "لايمكن التراجع عن هذه العملية",
                  onConfirm: () => {
                    handleDeleteClick(id);
                  },
                });
              }}
            >
              حذف
              <img
                src="deleteicon.svg"
                className="icondelete"
                alt="delete icon"
              ></img>
            </Button>
            <ConfirmDialog
             confirmDialog={confirmDialog}
             setConfirmDialog={setConfirmDialog}
           />,
          </Box>
        );
      },
    },
  ];
  return (
    <Box m="2px 5px 0px 5px">
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGridPro
          rows={users}
          className="field-table"
          columns={columns}
          editMode="row"
          pageSize={10}
          pagination
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          localeText={{
          toolbarColumns: "الأعمدة",
          toolbarFilters: "الفلاتر",
          toolbarDensity: "التباعد",
          toolbarExport: "تصدير",
          filterPanelAddFilter:'إضافة فلتر',
          filterOperatorContains:'تحتوي',
          filterOperatorEquals:'تساوي',
          filterOperatorStartsWith:'تبدأ ب',
          filterOperatorEndsWith:'تنتهي  ب',
          filterOperatorIsAnyOf:'هو أي من',
          filterOperatorIsEmpty:'فارغ',
          filterOperatorIsNotEmpty:'غير فارغ',
          toolbarDensityCompact:'دمج',
          toolbarDensityStandard:'معيار',
          toolbarDensityComfortable:'مريح',
          toolbarExportCSV:'تصدير CSV',
          toolbarExportPrint:'طباعة',
          filterPanelInputLabel:'القيمة',
          filterPanelInputPlaceholder:"ادخل القيمة",
          filterPanelColumns:'الاعمدة',
          filterPanelOperators:'العمليات',
          columnsPanelTextFieldLabel:'بحث عن عمود',
          columnsPanelTextFieldPlaceholder:'',
        }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    </Box>
  );
};

export default Provider_MTN;
